module.exports = __webpack_public_path__ + "images/star.682204414eca1db224b048c9f7f428b9.png";